import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import LatestNews from './components/LatestNews';
import CategorySection from './components/CategorySection';
import UserReviews from './components/UserReviews';
import CTASection from './components/CTASection';
import { homepageSchema } from '@/mocks/homeData';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '吃瓜网官网',
  alternateName: '51吃瓜网官网 · 91吃瓜网官网 · 黑料吃瓜网官网',
  url: 'http://my783e.cn/',
  description: '吃瓜网官网首页入口，提供51吃瓜网官网、91吃瓜网官网、黑料吃瓜网官网等最新热门吃瓜爆料内容。',
  sameAs: ['#', '#', '#'],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://my783e.cn/',
    },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '吃瓜网官网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网官网是一个每日更新的娱乐八卦资讯平台，提供51吃瓜网官网、91吃瓜网官网、黑料吃瓜网官网等最新热门爆料内容，涵盖网红塌房、明星黑料、博主反差视频等网络热门事件。',
      },
    },
    {
      '@type': 'Question',
      name: '吃瓜网官网多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网官网每日更新，第一时间跟进网络热门事件。关注度高的爆料会在事发后1-2小时内发布详细报道，确保读者第一时间获取最新资讯。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在吃瓜网官网找到想看的内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '吃瓜网官网提供明星黑料、网红塌房、博主反差等多个分类频道，您可以通过顶部导航栏快速进入感兴趣的分类。此外，首页每日精选推荐最新最热的爆料内容，方便您快速浏览。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageMeta
        schemaData={[organizationSchema, homepageSchema, breadcrumbSchema, faqSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <LatestNews />
        <CategorySection />
        <UserReviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}